import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useUserAuth } from "../context/UserAuthContext";
import axios from "axios";
import { authentication } from "../store/firebase-config";
import DeleteProfilePopup from "../Components/DeleteProfilePopup/DeleteProfilePopup";

export default function ProfileDeleteConfirmPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [userDeletePopup, setUserDeletePopup] = useState(false);
  const [data, setData] = useState();
  const { currentUser, verifiedDeletion } = useUserAuth();
  useEffect(() => {
    if (!verifiedDeletion) {
      navigate("/profile/delete");
    }
  }, []);
  useEffect(() => {
    loadDetails();
  }, []);
  const loadDetails = async () => {
    try {
      const data = await axios.get(
        `https://storage.googleapis.com/goviralcampaign/profileDelete.json`
      );
      setData(data.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  const deleteUserDetails = async () => {
    setLoading(true);
    try {
      let config = {
        method: "PATCH",
        url: process.env.REACT_APP_DELETE_USERS,
        headers: {
          Authorization: `Bearer ${currentUser?.accessToken}`,
        },
      };
      const response = await axios(config);
      if (response?.data?.status == "success") {
        try {
          await authentication.currentUser.delete();
          console.log("User deleted successfully from Firebase");
        } catch (error) {
          console.error("Error deleting user from Firebase:", error.message);
        }
        setLoading(false);
        setUserDeletePopup(true);
        authentication.signOut();
      }

      return;
    } catch (err) {
      setLoading(false);
      console.log(err, "error");
    }
  };
  return (
    <div className="widthController">
      <div className="pb-[80px]">
        <div className="flex flex-col bg-black px-[16px] pt-[30px]">
          {data?.data?.map((obj) => {
            return (
              <>
                {obj.heading && (
                  <span
                    className={`mb-[10px] mt-[30px] text-[${obj.color}] text-[${obj.size}] ${obj?.className}`}
                  >
                    {obj.heading}
                  </span>
                )}
                {obj.paragraph && (
                  <span
                    className={`mb-[20px] text-[${obj.color}] text-[${obj.size}] ${obj?.className}`}
                  >
                    {obj.paragraph}
                  </span>
                )}
              </>
            );
          })}

          <div className="mt-[20px] flex justify-evenly items-center">
            <button
              onClick={() => navigate("/profile")}
              className=" text-[12px] text-[#fff] rounded-[30px] border-[1px] border-[#787878] px-[10px] py-[4px]"
            >
              Cancel
            </button>
            <button
              onClick={() => deleteUserDetails()}
              disabled={loading}
              className="bg-[#095a2d] text-[12px] text-[#fff] rounded-[30px] border-[1px] border-[#787878] px-[10px] py-[4px]"
            >
              {loading ? "Loading" : "Delete Request"}
            </button>
          </div>
        </div>
        {userDeletePopup && <DeleteProfilePopup />}
      </div>
    </div>
  );
}
